import { cloneDeep } from 'lodash-es';
import { Pipe, PipeTransform } from '@angular/core';
import { PriceConfig } from '../../../types';
import { select, Store } from '@ngrx/store';
import {
  selectFilePrices,
  selectFilesInBasket,
  selectFileVouchers,
  selectPhotoGroups,
  selectPhotosList,
} from '../../actions/selector';
import { ShoppingCartState } from '../../actions/standalone';

import { map, switchMap } from 'rxjs';

@Pipe({
  name: 'filePriceWithVoucher',
  standalone: false,
})
export class FilePriceWithVoucherPipe implements PipeTransform {
  voucher$ = this.store.pipe(select(selectFileVouchers));
  photoGroup$ = this.store.pipe(select(selectPhotoGroups));
  filesInBasket$ = this.store.pipe(select(selectFilesInBasket));
  filePricesList$ = this.store.pipe(select(selectFilePrices));
  photosList$ = this.store.pipe(select(selectPhotosList));

  constructor(private store: Store<{ shoppingCart: ShoppingCartState }>) {}

  transform(a: Array<PriceConfig>) {
    const value = cloneDeep(a);
    return this.filesInBasket$.pipe(
      map((filesInBasket) => ({
        filesInBasket,
      })),
      switchMap(({ filesInBasket }) =>
        this.photosList$.pipe(
          map((photosList) => ({
            filesInBasket,
            photosList,
          })),
        ),
      ),
      switchMap(({ filesInBasket, photosList }) =>
        this.photoGroup$.pipe(
          map((photoGroup) => ({
            filesInBasket,
            photosList,
            photoGroup,
          })),
        ),
      ),
      switchMap(({ filesInBasket, photosList, photoGroup }) =>
        this.filePricesList$.pipe(
          map((filePrices) => ({
            filesInBasket,
            photosList,
            photoGroup,
            filePrices,
          })),
        ),
      ),
      switchMap(({ filesInBasket, photosList, photoGroup, filePrices }) =>
        this.voucher$.pipe(
          map((vouchers) => ({
            filesInBasket,
            photosList,
            photoGroup,
            filePrices,
            vouchers,
          })),
        ),
      ),
      map(({ filesInBasket, photosList, photoGroup, filePrices, vouchers }) => {
        let prices: Array<PriceConfig> = [];
        const allPrice: Array<PriceConfig> = [];
        filesInBasket.forEach((fileInBasket) => {
          if (
            photoGroup.find(
              (groups) =>
                groups.photoGroupId ===
                photosList
                  .find(({ photos }) =>
                    photos.find(
                      ({ photoId }) => photoId === fileInBasket.photoId,
                    ),
                  )
                  ?.photos.find(
                    ({ photoId }) => photoId === fileInBasket.photoId,
                  ).photoGroupId,
            )?.config.individualSellSettings &&
            photoGroup.find(
              (groups) =>
                groups.photoGroupId ===
                photosList
                  .find(({ photos }) =>
                    photos.find(
                      ({ photoId }) => photoId === fileInBasket.photoId,
                    ),
                  )
                  .photos.find(
                    ({ photoId }) => photoId === fileInBasket.photoId,
                  ).photoGroupId,
            )?.config.sellFiles &&
            photoGroup.find(
              (groups) =>
                groups.photoGroupId ===
                photosList
                  .find(({ photos }) =>
                    photos.find(
                      ({ photoId }) => photoId === fileInBasket.photoId,
                    ),
                  )
                  .photos.find(
                    ({ photoId }) => photoId === fileInBasket.photoId,
                  ).photoGroupId,
            )?.config.customFilesPricing
          ) {
            prices = photoGroup
              .find(
                (groups) =>
                  groups.photoGroupId ===
                  photosList
                    .find(({ photos }) =>
                      photos.find(
                        ({ photoId }) => photoId === fileInBasket.photoId,
                      ),
                    )
                    .photos.find(
                      ({ photoId }) => photoId === fileInBasket.photoId,
                    ).photoGroupId,
              )
              .config.files.find(
                (file) => file.size === fileInBasket.size,
              ).price;
          } else {
            prices = filePrices.length
              ? filePrices.find(
                  (filePrice) => filePrice.size === fileInBasket.size,
                )?.price
              : [{ price: 0, code: 'PLN' }];
          }
        });
        prices?.forEach((price) => {
          if (
            allPrice &&
            allPrice.find((value1) => value1.code === price.code)
          ) {
            allPrice.find((value1) => value1.code === price.code).price +=
              price.price;
          } else {
            allPrice.push(price);
          }
        });
        const discount: Array<{ code: string; discount: number }> = [];
        if (vouchers && vouchers.length) {
          vouchers.forEach((voucher) => {
            voucher.price.forEach((currentPrice) => {
              if (
                allPrice.find(
                  (x) =>
                    x.code === currentPrice.code &&
                    x.price >= currentPrice.price,
                )
              ) {
                if (discount.find((x) => x.code === currentPrice.code)) {
                  discount.find((x) => x.code === currentPrice.code).discount =
                    voucher.percentDiscount;
                } else {
                  discount.push({
                    code: currentPrice.code,
                    discount: voucher.percentDiscount,
                  });
                }
              }
            });
          });
        }
        if (discount && discount.length) {
          a.forEach((currentPrice) => {
            if (!discount.find((x) => x.code === currentPrice.code)) {
              discount.push({ discount: 0, code: currentPrice.code });
            }
            value.find(({ code }) => code === currentPrice.code).price -=
              (currentPrice.price / 100) *
              discount.find((x) => x.code === currentPrice.code).discount;
          });
        }
        return value;
      }),
    );
  }
}
